import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { LoadingService } from 'src/app/services/loading/loading.service';

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.css'],
})
export class ForgetPasswordComponent {
  email: string = '';

  constructor(private authService: AuthService, private router: Router, private loader: LoadingService) {}

  forgetPassowrd() {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(this.email)) {
      alert('Please enter a valid email address');
      return;
    }
    this.loader.showLoading();
    this.authService.forgotPassword(this.email).subscribe({
      next: (response) => {
        this.loader.hideLoading();
        this.router.navigate(['/verify-otp'], {
          queryParams: { email: this.email }
        });
      },
      error: (error) => {
        this.loader.hideLoading();
      },
    });
  }
}
